import { type JobForWizard } from '../queries/job';

export function getParametersForHook(
  currentJobState: Pick<
    JobForWizard,
    | 'targetCareerJumpers'
    | 'addressing'
    | 'targetJobTitles'
    | 'targetExperiences'
    | 'targetEducations'
    | 'targetSkills'
    | 'locations'
    | 'hook'
  >,
) {
  return {
    targetCareerJumpers: currentJobState.targetCareerJumpers,
    addressing: currentJobState.addressing,
    targetJobTitle: currentJobState.targetJobTitles?.length
      ? currentJobState.targetJobTitles.map((title) => title.label)
      : undefined,
    targetExperience: currentJobState.targetExperiences?.length
      ? currentJobState.targetExperiences.map((exp) => exp.label)
      : undefined,
    targetEducation: currentJobState.targetEducations?.length
      ? currentJobState.targetEducations.map((edu) => edu.label)
      : undefined,
    targetSkill: currentJobState.targetSkills?.length
      ? currentJobState.targetSkills.map((skill) => skill.label)
      : undefined,
    locations: currentJobState.locations?.map((location) => {
      const labelAttr =
        currentJobState.addressing === 'english' ? 'label_en' : 'label';
      return location[labelAttr]!;
    }),
  };
}
